import React from 'react'
import {useSharedStore} from '../../../../state/shared-store-context'
import {ToolbarNotifications} from './toolbar-notifications'

export const FooterNotifications = ({rootElementRef, containerName, fadingOut}) => {
    const {sharedState} = useSharedStore()
    return <ToolbarNotifications
        rootElementRef={rootElementRef}
        containerName={containerName}
        floatingPosition={sharedState.floatingFooterPosition}
        isHidden={sharedState.scrolledPast320 && !sharedState.noHideFooter && sharedState.footerContent}
        hasContent={sharedState.footerContent}
        floating={sharedState.floatingFooter}
        fadingOut={fadingOut}
        top
    />
}
